module.exports = __webpack_public_path__ + "img/emoji-smile.a8f675f5.svg";